<template>
  <div>
    <div class="ui grid">
      <div class="sixteen wide column">
        <booking></booking>
      </div>
    </div>
  </div>
</template>

<script>
import Booking from '../Booking.vue'

export default {
  components: {
    Booking
  }
}
</script>



// WEBPACK FOOTER //
// Home.vue?5c5e20f2